<template>
<div>
    <h1 class="display-heading">Vaccination Clinic List</h1>
    <div class="table-responsive">
        <div ref="tableSection">
            <table ref="listTable" class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                        <th scope="col">Region</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="vaccinationCentres.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <tr v-for="(vaccinationCentre, index) in vaccinationCentres" :key="index">
                        <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                        <td>{{vaccinationCentre.name}}</td>
                        <td>{{vaccinationCentre.phone }}</td>
                        <td>{{vaccinationCentre.email}}</td>
                        <td>{{vaccinationCentre.region}}</td>
                        <td>
                            <router-link :to="{
                                'name': 'admin-vaccination-centre',
                                'params': {'id': vaccinationCentre.id}
                            }">
                            View Details
                            </router-link>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>

        <pagination v-model="pagination.currentPage"
            :totalPages="pagination.totalPages"
            :scrollPosition="pagination.scrollPosition">
        </pagination>
    </div>
</div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'VaccinationDashboard',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getVaccinationCentres();
            });
        }
    },
    data () {
        return {
            convertToUserReadableDateTime,
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'vaccinationCentres': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getVaccinationCentres();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getVaccinationCentres () {
            this.axios.get('VaccinationCentre/List', {
                'params': {
                    'page': this.pagination.currentPage,
                    'pageSize': this.pagination.pageSize,
                    'status': 4
                }
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.vaccinationCentres = list.map((vaccinationCentre) => ({
                    'id': vaccinationCentre.i,
                    'name': vaccinationCentre.n,
                    'phone': vaccinationCentre.ph,
                    'email': vaccinationCentre.e,
                    'region': vaccinationCentre.rn
                }));
            });
        }
    }
};
</script>

<style>

</style>
